import type { ISpecCategories } from '../../spec/SpecCategories';

/**
 * Class representing a FIX field category type.
 * Stores and manages category-specific information for FIX fields.
 */
export class CategoryType {
    /** The unique identifier for the category */
    public categoryID: string | undefined = undefined;
    /** The FIXML file name associated with this category */
    public fixmlFileName: string | undefined = undefined;
    /** The type of component this category represents */
    public componentType: string | undefined = undefined;
    /** The section ID this category belongs to */
    public sectionID: string | undefined = undefined;
    /** The include file associated with this category */
    public includeFile: string | undefined = undefined;

    /**
     * Sets the category properties based on the provided category specification.
     *
     * @param {ISpecCategories} category - The category specification to set
     */
    public setCategory(category: ISpecCategories): void {
        this.categoryID = category.name;
        this.fixmlFileName = category.FIXMLFileName;
        this.componentType = category.componentType;
        this.sectionID = category.section!;
        this.includeFile = category.includeFile!;
    }

    /**
     * Resets all category properties to undefined.
     */
    public reset(): void {
        this.categoryID = undefined;
        this.fixmlFileName = undefined;
        this.componentType = undefined;
        this.sectionID = undefined;
        this.includeFile = undefined;
    }
}
